import { partition } from 'lodash';

import { EDimensionType } from '@src/common/constant/enum';

export function partitionOptions(data: any[] = [], disabledCallback?: (dimension: any) => boolean) {
  const mapToOptions = (dimensions) =>
    dimensions.map((dimension, index) => ({
      key: `${dimension.display_name}_${index}`,
      label: dimension.display_name,
      value: dimension.dimension_name,
      disabled: disabledCallback?.(dimension),
    }));

  const [userDefinedDimension, systemDimension] = partition(data ?? [], {
    dimension_type: EDimensionType.USER_DEFINED,
  });
  const defaultOptions = mapToOptions(data ?? []);
  const userDefinedOptions = mapToOptions(userDefinedDimension);
  const systemOptions = mapToOptions(systemDimension);

  return {
    defaultOptions,
    userDefinedOptions,
    systemOptions,
    options: [
      {
        key: 'System Dimensions',
        label: 'System Dimensions',
        options: systemOptions,
      },
      {
        key: 'Custom Dimensions',
        label: 'Custom Dimensions',
        options: userDefinedOptions,
      },
    ],
  };
}
